import type { Account } from '../../generated-types';
import { OutboxWrapper } from '../../models/outbox';

export default (accounts: Account[], outboxItem: OutboxWrapper): Account | undefined => {
    if (!outboxItem.from?.accountNumber) return undefined;
    return accounts.find((x) => x.accountNumber.value === outboxItem.from?.accountNumber?.value);
};
